/** Print overrides, applied under `@media print`. */
export const printTheme = {
  fontFamily:
    "'Inter', 'Source Sans 3', Poppins, 'Helvetica Neue', Tahoma, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji','Segoe UI Symbol', 'Noto Color Emoji'",
  fontSerifFamily:
    "'Source Serif 4', 'Noto Serif' , serif, 'Cambria', 'Helvetica Neue', Tahoma, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji','Segoe UI Symbol', 'Noto Color Emoji'",
  fontMonoFamily:
    "'Source Code Pro', 'IBM Plex Mono', 'Roboto Mono','Noto Sans Mono', 'Noto Sans CJK',  'Helvetica Neue', Tahoma, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji','Segoe UI Symbol', 'Noto Color Emoji'",
  fontSansFamily:
    "'Inter', 'Source Sans 3', Poppins, 'Helvetica Neue', Tahoma, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji','Segoe UI Symbol', 'Noto Color Emoji'",
  fontNumberFamily:
    "'Roboto Mono', 'Noto Sans Mono', 'Helvetica Neue', Tahoma, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji','Segoe UI Symbol', 'Noto Color Emoji'",
  fontCodeFamily:
    "'IBM Plex Mono', 'Space Mono', Consolas, Menlo, Monaco, Courier, monospace, 'Helvetica Neue', Tahoma, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji','Segoe UI Symbol', 'Noto Color Emoji'",
};
